module.exports = __webpack_public_path__ + "img/drizzle-dark.077fa7b3.png";